export default {
  ecofrostList: [],
  ecofrostCurrent: {},
  ecofrostPagination: {
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 0
  },
  ecofrostLoading: false
};
